__turbopack_context__.v({
  "divider": "divider-module-scss-module__Jem89G__divider",
  "divider_line": "divider-module-scss-module__Jem89G__divider_line",
  "divider_logo": "divider-module-scss-module__Jem89G__divider_logo",
});
